import PedidoDevolucaoMaterialNovo from './PedidoDevolucaoMaterialNovo';

export default PedidoDevolucaoMaterialNovo;